import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { BoardService } from '@main-application/boards/services/board.service';
import {
  getTemplatesUsage,
  getTemplatesUsageFailed,
  getTemplatesUsageSuccess,
  loadBoardList,
  loadBoardListFailed,
  loadBoardListSuccess,
  loadBoardSummaryDetails,
  loadBoardSummaryDetailsFailed,
  loadBoardSummaryDetailsSuccess,
  loadBoardSummaryStats,
  loadBoardSummaryStatsFailed,
  loadBoardSummaryStatsSuccess,
  updateTemplateUsage,
  updateTemplateUsageFailed,
  updateTemplateUsageSuccess,
} from '@main-application/boards/store/boards.actions';

@Injectable()
export class BoardsEffects {
  loadBoardList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBoardList),
      mergeMap(() =>
        this.boardService.getList().pipe(
          map(boards => loadBoardListSuccess({ boards })),
          catchError(err => {
            return of(loadBoardListFailed());
          })
        )
      )
    )
  );

  updateTemplateUsage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateTemplateUsage),
      mergeMap(action =>
        this.boardService.updateTemplateUsage(action.usage).pipe(
          map(() => updateTemplateUsageSuccess()),
          catchError(() => of(updateTemplateUsageFailed()))
        )
      )
    )
  );

  getTemplatesUsage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getTemplatesUsage),
      mergeMap(action =>
        this.boardService.getTemplatesUsage(action.id).pipe(
          map(templatesUsage => {
            return getTemplatesUsageSuccess({ templatesUsage });
          }),
          catchError(error => {
            return of(getTemplatesUsageFailed({ error }));
          })
        )
      )
    )
  );

  loadBoardSummaryStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBoardSummaryStats),
      mergeMap(action =>
        this.boardService.getBoardSummaryStats(action.filter).pipe(
          map(stats => loadBoardSummaryStatsSuccess({ stats })),
          catchError(error => of(loadBoardSummaryStatsFailed({ error })))
        )
      )
    )
  );

  loadBoardSummaryDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBoardSummaryDetails),
      mergeMap(action =>
        this.boardService.getBoardSummaryDetails(action.filter).pipe(
          map(details => loadBoardSummaryDetailsSuccess({ details })),
          catchError(error => of(loadBoardSummaryDetailsFailed({ error })))
        )
      )
    )
  );

  constructor(private actions$: Actions, private boardService: BoardService) {}
}
